import { render, staticRenderFns } from "./YcHomeList.vue?vue&type=template&id=e0824d1e&scoped=true"
import script from "./YcHomeList.vue?vue&type=script&lang=js"
export * from "./YcHomeList.vue?vue&type=script&lang=js"
import style0 from "./YcHomeList.vue?vue&type=style&index=0&id=e0824d1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0824d1e",
  null
  
)

export default component.exports